// today
const minDateNow = () => {
  let isNow = new Date()
  let month = isNow.getMonth() + 1
  let day = isNow.getDate()
  let today = isNow.getFullYear() + '-' + (('' + month).length < 2 ? '0' : '') + month + '-' + (('' + day).length < 2 ? '0' : '') + day
  return today
}

export default () => ({
  show: false,
  isLoading: true,
  onCancel: false,
  fullPage: true,
  moving: {
    tower_id: null,
    unit_id: null,
    go_in_out: null,
    type: null,
    status: true,
    _lock_go_in_out: false
  },
  movings: [],
  entity: 'moving',
  entities: 'movings',
  dwellerUnits: [],
  dwellerTowers: [],
  optionType: [
    {
      id: 'in',
      label: 'Entrada'
    },
    {
      id: 'out',
      label: 'Saida'
    }
  ],
  optionStatus: [
    {
      id: true,
      label: 'Ativo'
    },
    {
      id: false,
      label: 'Inativo'
    }
  ],
  miniDate: minDateNow(),
  prefixRouter: 'tenant.moving'
})



// WEBPACK FOOTER //
// ./src/app/tenant/moving/resources/data.js